export enum IncomeTaxYearTypesEnum {
  Unknown = 0,
  SameAsFiscalYear = 1,
  January = 2
}
